// extracted by mini-css-extract-plugin
export var primitiveLabel = "_wb-0";